module.exports = __webpack_public_path__ + "img/box_hydrogen_grey.9280cc50.png";